import React from "react";

const Home = () => (
  <React.Fragment>
    <div className="home-page">
      <h1>Welcome to Hack the North 2021</h1>
    </div>
  </React.Fragment>
);

export default Home;
